import React, { useEffect, useState } from "react";
import SectionHeader from "../SectionHeader/SectionHeader";
import { useSiteData } from "../../Contexts/SiteContext";
import { isIncluded } from "../../Datas/Functions/shareFunctions";
import Spinner from "../SiteComponants/SmallComponents/Spinner";
import moment from "moment";

const Last5Order = () => {
  const { orderList } = useSiteData();
  const [showLastFive, setShowLastFive] = useState([]);
  useEffect(() => {
    const newShowlist = orderList
      ?.filter((order) => isIncluded(order.order_status, "compl") === true)
      .sort((a, b) => parseInt(b.created_at) - parseInt(a.created_at))
      .slice(0, 5);
    setShowLastFive(newShowlist);
    console.log(newShowlist);
  }, [orderList]);
  return (
    <div className="container my-20">
      <SectionHeader
        heading={"Recent Completed Orders"}
        className={"text-center"}
      />

      <div className="w-full md:w-11/12  mx-auto">
        <div className="box  capitalize overflow-auto">
          <table className="table w-full text-left ">
            <thead>
              <tr className="border-b border-b-orange-500">
                <th className="pl-2 pr-5 py-5">Order No</th>
                <th className="pl-2 pr-5 py-5">Cutomer</th>
                <th className="pl-2 pr-5 py-5">Product</th>
                <th className="pl-2 pr-5 py-5">Purchased</th>
              </tr>
            </thead>
            <tbody className="">
              {showLastFive.length > 0 ? (
                showLastFive.map((order, i) => (
                  <tr
                    key={i}
                    className="border-b last:border-b-0 border-b-orange-500"
                  >
                    <td className="pl-2 pr-5 py-5">{i + 1}</td>
                    <td className="pl-2 pr-5 py-5">{order.customer_name}</td>
                    <td className="pl-2 pr-5 py-5">{order.order_name}</td>
                    <td className="pl-2 pr-5 py-5">
                      {moment(parseInt(order.created_at)).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                ))
              ) : (
                <Spinner />
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Last5Order;
